import {Product} from '@hconnect/apiclient'
import {useEffect} from 'react'
import {UseFormReturn} from 'react-hook-form'

import {WidgetUserCreationFormData} from '../WidgetUserCreation.form'

export const useAutoSelectCountry = (
  cscCountries: string[] | undefined,
  formMethods: UseFormReturn<WidgetUserCreationFormData>
) => {
  useEffect(() => {
    if (cscCountries && cscCountries.length === 1 && !formMethods.watch('country')) {
      formMethods.setValue('country', cscCountries[0], {shouldDirty: false})
    }
  }, [cscCountries, formMethods])
}

export const useProductValidation = (
  selectedProducts: Product[] | undefined,
  formMethods: UseFormReturn<WidgetUserCreationFormData>
) => {
  useEffect(() => {
    if (selectedProducts !== undefined) {
      formMethods.setValue('products', selectedProducts)
      if (selectedProducts.find((product) => product === Product.Hub)) {
        void formMethods.trigger('email')
        formMethods.clearErrors('mobileNumber')
      }

      if (selectedProducts.find((product) => product === Product.OnSite)) {
        void formMethods.trigger('mobileNumber')
        formMethods.clearErrors('email')
      }

      if (selectedProducts.length === 0) {
        void formMethods.trigger('email')
        void formMethods.trigger('mobileNumber')
      }
    }
  }, [selectedProducts, formMethods])
}

export const usePermissionSync = (
  isCreateOrderPermissionSelected: boolean,
  formMethods: UseFormReturn<WidgetUserCreationFormData>
) => {
  useEffect(() => {
    if (isCreateOrderPermissionSelected) {
      const currentPermissions = formMethods.watch('permissions')
      formMethods.setValue(
        'permissions',
        {
          ...currentPermissions,
          canChangeOrders: true
        },
        {shouldDirty: true}
      )
    }
  }, [isCreateOrderPermissionSelected, formMethods])
}

